export const TRADE_TYPES = [
  {
    id: "long_seagull",
    label: "Long Seagull",
    category: "Options Structure",
    tag: "OPTIONS",
    description: "Premium-neutral upside structure with defined downside floor.",
    color: "#00C2FF",
    icon: "◈",
    fields: [
      { key: "asset", label: "Asset / Underlying", type: "text", placeholder: "e.g. ETH, BTC, SOL", default: "BTC" },
      { key: "spot", label: "Spot Price ($)", type: "number", placeholder: "2300", default: "70200" },
      { key: "contracts", label: "Number of Contracts", type: "number", placeholder: "1000", default: "100" },
      { key: "lower_put", label: "Short Put Strike ($)", type: "number", placeholder: "2000", default: "62000" },
      { key: "lower_call", label: "Long Call Strike ($)", type: "number", placeholder: "2500", default: "75000" },
      { key: "upper_call", label: "Short Call Strike ($)", type: "number", placeholder: "2900", default: "90000" },
      { key: "max_pnl", label: "Max P&L ($)", type: "number", placeholder: "400000", default: "1500000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "28 Mar 2025", default: "26 Jun 2026" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade...", default: "Following recent downside pressure and elevated volatility across crypto markets, many investors are positioning for a rebound over the next 1-2 months. This structure is designed to capitalize on near-term bullish momentum while remaining more capital-efficient than purchasing spot outright. Implemented as a zero-cost option strategy, it provides upside participation on Bitcoin between $75,000 and $90,000, with downside risk only materializing if BTC settles below $62,000 at expiry. The trade is well-suited for investors seeking exposure to a tactical bounce without committing the capital required for equivalent spot BTC exposure." },
    ]
  },
  {
    id: "reverse_cash_carry",
    label: "Reverse Cash & Carry",
    category: "Basis Trade",
    tag: "CRYPTO",
    description: "Unlock liquidity while maintaining price exposure via perpetual futures.",
    color: "#F7931A",
    icon: "⟳",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "spot_price", label: "Spot Price ($)", type: "number", placeholder: "100000", default: "100000" },
      { key: "btc_amount", label: "Holdings (Units)", type: "number", placeholder: "100", default: "100" },
      { key: "portfolio_value", label: "Portfolio Value ($)", type: "number", placeholder: "10000000", default: "10000000" },
      { key: "margin_pct", label: "Margin Posted (%)", type: "number", placeholder: "15", default: "15" },
      { key: "cash_released_pct", label: "Cash Released (%)", type: "number", placeholder: "85", default: "85" },
      { key: "exchange", label: "Execution Venue", type: "text", placeholder: "e.g. Deribit, Binance", default: "Deribit" },
      { key: "funding_rate", label: "Est. Funding Rate (APR %)", type: "number", placeholder: "10", default: "10" },
      { key: "client_use_case", label: "Client Use Case", type: "select", options: ["Liquidity Unlock", "Yield Farming", "Tax Optimization", "Diversification", "Capital Redeployment", "Treasury Management"], default: "Liquidity Unlock" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "covered_call",
    label: "Covered Call",
    category: "Income Strategy",
    tag: "OPTIONS",
    description: "Collect premium by selling calls against an existing long crypto position.",
    color: "#4ADE80",
    icon: "↗",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH, SOL", default: "BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "10", default: "10" },
      { key: "cost_basis", label: "Cost Basis ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "strike", label: "Call Strike ($)", type: "number", placeholder: "105000", default: "105000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "28 Mar 2025", default: "26 Jun 2026" },
      { key: "premium", label: "Premium Collected ($)", type: "number", placeholder: "2500", default: "2500" },
      { key: "delta", label: "Delta", type: "number", placeholder: "0.20", default: "0.20" },
      { key: "dte", label: "Days to Expiry (DTE)", type: "number", placeholder: "30", default: "30" },
      { key: "iv_rank", label: "IV Rank (%)", type: "number", placeholder: "65", default: "65" },
      { key: "resistance_level", label: "Key Resistance Level ($)", type: "number", placeholder: "102000", default: "102000" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "cash_secured_put",
    label: "Cash-Secured Put",
    category: "Income Strategy",
    tag: "OPTIONS",
    description: "Sell puts to generate income or acquire crypto at a discount.",
    color: "#A78BFA",
    icon: "↓",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "strike", label: "Put Strike ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "28 Mar 2025", default: "26 Jun 2026" },
      { key: "premium", label: "Premium Collected ($)", type: "number", placeholder: "3500", default: "3500" },
      { key: "delta", label: "Delta", type: "number", placeholder: "-0.20", default: "-0.20" },
      { key: "dte", label: "Days to Expiry (DTE)", type: "number", placeholder: "30", default: "30" },
      { key: "iv_rank", label: "IV Rank (%)", type: "number", placeholder: "72", default: "72" },
      { key: "support_level", label: "Key Support Level ($)", type: "number", placeholder: "82000", default: "82000" },
      { key: "effective_basis", label: "Effective Cost Basis if Assigned ($)", type: "number", placeholder: "81500", default: "81500" },
      { key: "capital_required", label: "Capital Required ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "leap",
    label: "Long-Dated Option",
    category: "Long Directional",
    tag: "OPTIONS",
    description: "Long-dated call option as leveraged directional bet with defined risk.",
    color: "#FB923C",
    icon: "⤴",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH, SOL", default: "BTC" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "strike", label: "Strike Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "26 Dec 2025", default: "26 Dec 2026" },
      { key: "dte", label: "Days to Expiry (DTE)", type: "number", placeholder: "300", default: "300" },
      { key: "premium", label: "Premium Paid ($)", type: "number", placeholder: "12000", default: "12000" },
      { key: "delta", label: "Delta", type: "number", placeholder: "0.65", default: "0.65" },
      { key: "iv_rank", label: "IV Rank (%)", type: "number", placeholder: "28", default: "28" },
      { key: "contracts", label: "Contracts", type: "number", placeholder: "10", default: "10" },
      { key: "total_outlay", label: "Total Capital at Risk ($)", type: "number", placeholder: "120000", default: "120000" },
      { key: "target_price", label: "Price Target ($)", type: "number", placeholder: "120000", default: "120000" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "wheel",
    label: "The Wheel",
    category: "Income Strategy",
    tag: "OPTIONS",
    description: "Systematic premium collection cycling through puts and covered calls.",
    color: "#34D399",
    icon: "⟲",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "holdings", label: "Holdings (units)", type: "number", placeholder: "1", default: "1" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "current_phase", label: "Current Phase", type: "select", options: ["Selling Puts", "Assigned - Holding Position", "Selling Covered Calls"], default: "Selling Covered Calls" },
      { key: "original_strike", label: "Original Put Strike ($)", type: "number", placeholder: "88000", default: "88000" },
      { key: "cost_basis", label: "Current Adjusted Cost Basis ($)", type: "number", placeholder: "82000", default: "82000" },
      { key: "total_premium", label: "Total Premium Collected to Date ($)", type: "number", placeholder: "9500", default: "9500" },
      { key: "cycles_completed", label: "Cycles Completed", type: "number", placeholder: "3", default: "3" },
      { key: "current_strike", label: "Current Active Strike ($)", type: "number", placeholder: "100000", default: "100000" },
      { key: "current_premium", label: "Current Premium (Total $)", type: "number", placeholder: "4200", default: "4200" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "e.g. 21 Jun 2026", default: "26 Jun 2026" },
      { key: "dte", label: "Days to Expiry", type: "number", placeholder: "30", default: "30" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "collar",
    label: "Protective Collar",
    category: "Hedging",
    tag: "HEDGING",
    description: "Protect downside with a put while funding it by selling an upside call.",
    color: "#F472B6",
    icon: "⊡",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "50", default: "50" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "cost_basis", label: "Cost Basis ($)", type: "number", placeholder: "72000", default: "72000" },
      { key: "put_strike", label: "Put Strike (Floor) ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "call_strike", label: "Call Strike (Cap) ($)", type: "number", placeholder: "110000", default: "110000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "27 Jun 2025", default: "27 Jun 2026" },
      { key: "put_premium", label: "Put Premium Paid ($)", type: "number", placeholder: "4000", default: "4000" },
      { key: "call_premium", label: "Call Premium Received ($)", type: "number", placeholder: "3800", default: "3800" },
      { key: "net_cost", label: "Net Cost of Collar ($)", type: "number", placeholder: "200", default: "200" },
      { key: "protected_value", label: "Portfolio Value Protected ($)", type: "number", placeholder: "4250000", default: "4250000" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "call_spread_collar",
    label: "Call Spread Collar",
    category: "Options Structure",
    tag: "OPTIONS",
    description: "Downside protection with a soft upside cap — sell an ATM call to generate premium, buy an OTM call to restore tail participation.",
    color: "#F97316",
    icon: "⊞",
    fields: [
      { key: "asset",               label: "Asset / Underlying",                  type: "text",     placeholder: "BTC",         default: "BTC" },
      { key: "spot",                label: "Spot Price ($)",                       type: "number",   placeholder: "85000",       default: "85000" },
      { key: "notional",            label: "Notional (Units)",                     type: "number",   placeholder: "1",           default: "1" },
      { key: "put_strike",          label: "Put Strike ($) — Floor",               type: "number",   placeholder: "75000",       default: "75000" },
      { key: "short_call",          label: "Short Call Strike ($) — Cap",          type: "number",   placeholder: "85000",       default: "85000" },
      { key: "long_call",           label: "Long Call Strike ($) — Re-entry",      type: "number",   placeholder: "127500",      default: "127500" },
      { key: "put_premium",         label: "Put Premium Paid ($)",                 type: "number",   placeholder: "3500",        default: "3500" },
      { key: "short_call_premium",  label: "Short Call Premium Received ($)",      type: "number",   placeholder: "4200",        default: "4200" },
      { key: "long_call_premium",   label: "Long Call Premium Paid ($)",           type: "number",   placeholder: "1800",        default: "1800" },
      { key: "expiry",              label: "Expiry Date",                          type: "text",     placeholder: "27 Jun 2026", default: "27 Jun 2026" },
      { key: "executive_summary",   label: "Executive Summary",                    type: "textarea", placeholder: "Describe the trade rationale..." },
    ]
  },
  {
    id: "earnings_play",
    label: "Event Risk Analysis",
    category: "Event-Driven",
    tag: "CATALYST",
    description: "Assess and manage options risk around binary events (halving, ETF decisions, protocol upgrades, macro).",
    color: "#FBBF24",
    icon: "⚡",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "current_price", label: "Current Price ($)", type: "number", placeholder: "95000", default: "95000" },
      { key: "event_date", label: "Event Date", type: "text", placeholder: "15 Apr 2025", default: "15 Apr 2026" },
      { key: "expected_move_pct", label: "Market-Priced Expected Move (%)", type: "number", placeholder: "8.5", default: "8.5" },
      { key: "position_type", label: "Existing Position", type: "select", options: ["Short Put", "Long Call", "Covered Call", "Short Call Spread", "No Position"], default: "Short Put" },
      { key: "strike", label: "Position Strike ($)", type: "number", placeholder: "88000", default: "88000" },
      { key: "premium_collected", label: "Premium Collected ($)", type: "number", placeholder: "5000", default: "5000" },
      { key: "last_3_reactions", label: "Last 3 Event Reactions (%)", type: "text", placeholder: "+12%, -4%, +8%", default: "+12%, -4%, +8%" },
      { key: "recommendation", label: "Action Recommendation", type: "select", options: ["Hold Through Event", "Close Before Event", "Roll to Later Date", "Reduce Size"], default: "Hold Through Event" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "call_spread",
    label: "Call Spread",
    category: "Options Structure",
    tag: "OPTIONS",
    description: "Bull or bear call spread — capped upside or premium income with defined max risk.",
    color: "#378ADD",
    icon: "⟋",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "spot", label: "Spot Price", type: "number", placeholder: "84000" },
      { key: "direction", label: "Direction", type: "select", options: ["Long", "Short"] },
      { key: "long_strike", label: "Long Strike", type: "number", placeholder: "84000" },
      { key: "short_strike", label: "Short Strike", type: "number", placeholder: "92000" },
      { key: "premium", labelFn: (vals) => vals.direction === "Long" ? "Net Premium (Cost)" : "Net Premium (Income)", type: "number", placeholder: "-1450" },
      { key: "expiry", label: "Expiry", type: "text", placeholder: "28 Apr 2025" },
      { key: "iv", label: "IV", type: "text", placeholder: "62%" },
      { key: "delta", label: "Delta", type: "number", placeholder: "0.28" },
    ]
  },
  {
    id: "put_spread",
    label: "Put Spread",
    category: "Options Structure",
    tag: "OPTIONS",
    description: "Bear or bull put spread — defined downside hedge or yield with bounded loss.",
    color: "#E24B4A",
    icon: "⟍",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "spot", label: "Spot Price", type: "number", placeholder: "84000" },
      { key: "direction", label: "Direction", type: "select", options: ["Long", "Short"] },
      { key: "long_strike", label: "Long Strike (higher put)", type: "number", placeholder: "84000" },
      { key: "short_strike", label: "Short Strike (lower put)", type: "number", placeholder: "75000" },
      { key: "premium", label: "Net Premium (negative = debit)", type: "number", placeholder: "-2200" },
      { key: "expiry", label: "Expiry", type: "text", placeholder: "30 May 2025" },
      { key: "iv", label: "IV", type: "text", placeholder: "64%" },
      { key: "delta", label: "Delta", type: "number", placeholder: "-0.35" },
    ]
  },
  {
    id: "straddle",
    label: "Straddle",
    category: "Volatility",
    tag: "OPTIONS",
    description: "Long or short ATM call + put — profits from large moves or time decay at a single strike.",
    color: "#A78BFA",
    icon: "⟺",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "spot", label: "Spot Price", type: "number", placeholder: "84000" },
      { key: "direction", label: "Direction", type: "select", options: ["Long", "Short"] },
      { key: "atm_strike", label: "ATM Strike", type: "number", placeholder: "84000" },
      { key: "total_premium", label: "Total Premium (negative = debit)", type: "number", placeholder: "-4800" },
      { key: "expiry", label: "Expiry", type: "text", placeholder: "30 May 2025" },
      { key: "iv", label: "IV", type: "text", placeholder: "63%" },
      { key: "delta", label: "Delta", type: "number", placeholder: "0.02" },
    ]
  },
  {
    id: "strangle",
    label: "Strangle",
    category: "Volatility",
    tag: "OPTIONS",
    description: "Long or short OTM call + put — wider wings, lower cost than straddle with the same vol thesis.",
    color: "#34D399",
    icon: "⟻",
    fields: [
      { key: "asset", label: "Asset", type: "text", placeholder: "e.g. BTC" },
      { key: "holdings", label: "Holdings (Units)", type: "number", placeholder: "1", default: "1" },
      { key: "spot", label: "Spot Price", type: "number", placeholder: "84000" },
      { key: "direction", label: "Direction", type: "select", options: ["Long", "Short"] },
      { key: "call_strike", label: "OTM Call Strike", type: "number", placeholder: "90000" },
      { key: "put_strike", label: "OTM Put Strike", type: "number", placeholder: "76000" },
      { key: "total_premium", label: "Total Premium (negative = debit)", type: "number", placeholder: "-2900" },
      { key: "expiry", label: "Expiry", type: "text", placeholder: "30 May 2025" },
      { key: "iv", label: "IV", type: "text", placeholder: "60%" },
      { key: "delta", label: "Delta", type: "number", placeholder: "0.04" },
    ]
  },
  {
    id: "custom_spread",
    label: "Custom Spread",
    category: "Custom",
    tag: "CUSTOM",
    description: "Build any multi-leg option structure from scratch — up to 4 legs of long/short calls and puts with independent strikes, quantities, and premiums.",
    color: "#475569",
    icon: "⊟",
    fields: [
      { key: "asset", label: "Asset / Underlying", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "spot", label: "Spot Price ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "27 Jun 2026", default: "27 Jun 2026" },

      // Leg 1 (default to an active long call so a fresh trade renders meaningfully)
      { key: "leg1_type",    label: "Leg 1 — Type",             type: "select", options: ["None", "Long Call", "Short Call", "Long Put", "Short Put"], default: "Long Call" },
      { key: "leg1_strike",  label: "Leg 1 — Strike ($)",       type: "number", placeholder: "85000", default: "85000" },
      { key: "leg1_qty",     label: "Leg 1 — Quantity",         type: "number", placeholder: "1",     default: "1" },
      { key: "leg1_premium", label: "Leg 1 — Premium / Unit ($)", type: "number", placeholder: "2500", default: "2500" },

      // Leg 2 (default to an active short call so the new user sees a spread on first render)
      { key: "leg2_type",    label: "Leg 2 — Type",             type: "select", options: ["None", "Long Call", "Short Call", "Long Put", "Short Put"], default: "Short Call" },
      { key: "leg2_strike",  label: "Leg 2 — Strike ($)",       type: "number", placeholder: "95000", default: "95000" },
      { key: "leg2_qty",     label: "Leg 2 — Quantity",         type: "number", placeholder: "1",     default: "1" },
      { key: "leg2_premium", label: "Leg 2 — Premium / Unit ($)", type: "number", placeholder: "1100", default: "1100" },

      // Legs 3 and 4 default to None — extra capacity for butterflies, condors, seagulls, etc.
      { key: "leg3_type",    label: "Leg 3 — Type",             type: "select", options: ["None", "Long Call", "Short Call", "Long Put", "Short Put"], default: "None" },
      { key: "leg3_strike",  label: "Leg 3 — Strike ($)",       type: "number", placeholder: "",  default: "" },
      { key: "leg3_qty",     label: "Leg 3 — Quantity",         type: "number", placeholder: "1", default: "1" },
      { key: "leg3_premium", label: "Leg 3 — Premium / Unit ($)", type: "number", placeholder: "", default: "" },

      { key: "leg4_type",    label: "Leg 4 — Type",             type: "select", options: ["None", "Long Call", "Short Call", "Long Put", "Short Put"], default: "None" },
      { key: "leg4_strike",  label: "Leg 4 — Strike ($)",       type: "number", placeholder: "",  default: "" },
      { key: "leg4_qty",     label: "Leg 4 — Quantity",         type: "number", placeholder: "1", default: "1" },
      { key: "leg4_premium", label: "Leg 4 — Premium / Unit ($)", type: "number", placeholder: "", default: "" },

      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
  {
    id: "binary_option",
    label: "Binary Option",
    category: "Digital",
    tag: "BINARY",
    description: "All-or-nothing payoff — each contract pays $1 if the event occurs (price above strike for a call, below for a put), $0 otherwise. Premium is quoted as a probability percentage.",
    color: "#8B5CF6",
    icon: "◐",
    fields: [
      { key: "asset", label: "Asset / Underlying", type: "text", placeholder: "e.g. BTC, ETH", default: "BTC" },
      { key: "spot", label: "Spot Price ($)", type: "number", placeholder: "85000", default: "85000" },
      { key: "type", label: "Option Type", type: "select", options: ["Call", "Put"], default: "Call" },
      { key: "direction", label: "Direction", type: "select", options: ["Long", "Short"], default: "Long" },
      { key: "strike", label: "Strike ($)", type: "number", placeholder: "90000", default: "90000" },
      { key: "expiry", label: "Expiry Date", type: "text", placeholder: "30 May 2026", default: "30 May 2026" },
      { key: "quantity", label: "Quantity (Contracts)", type: "number", placeholder: "100000", default: "100000" },
      { key: "premium", label: "Premium (% — probability of event)", type: "number", placeholder: "40", default: "40" },
      { key: "executive_summary", label: "Executive Summary", type: "textarea", placeholder: "Provide market context, macro outlook, catalysts, and rationale for this trade..." },
    ]
  },
];
